import React, { createContext, useReducer } from "react";
import { OutboundConfigReducer } from "../reducers/OutboundConfigReducer";
import { DEFAULT_REFRESH_INTERVAL } from "../util/Constants";

export const OutboundConfigContext = createContext();

const OutboundConfigContextProvider = (props) => {
  const state = {
    stationConfig: {
      initialised: false,
      pickStageDecoupleEnabled: false,
      parallelPickEnabled: false,
      atRiskMetricV2: false,
      refreshInterval: DEFAULT_REFRESH_INTERVAL,
      sccV2OutboundViewForAREnabled: false,
      drsPickStageVisibilityEnabled: false,
      planFinalizationEnabled: false,
      tabularGridViewSSDEnabled: false,
      rswsbosonFlowEnabled: false,
      amxl: false,
      stagenabled: false,
      overviewMetricEnrichmentEnabled: false,
      atRiskMetricEnrichmentEnabled: false,
    },
  };
  const [outboundConfigModel, configDispatcher] = useReducer(
    OutboundConfigReducer,
    state,
  );
  return (
    <OutboundConfigContext.Provider
      value={{ outboundConfigModel, configDispatcher }}
    >
      {props.children}
    </OutboundConfigContext.Provider>
  );
};

export default OutboundConfigContextProvider;



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/context/OutboundConfigContext.js